var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87042 1.83923C3.61643 0.572476 2.619 1.19175 2.09775 1.91778C1.92012 2.16519 1.87025 2.47497 1.88043 2.77937C1.91275 3.74504 1.89909 5.0701 1.75072 9.06118C1.61623 12.6792 3.19399 14.1618 4.48248 14.9001C5.07101 15.2374 5.50009 15.8087 5.54384 16.4856L5.75777 19.7958C5.81979 20.7555 6.61633 21.5023 7.57808 21.5023H16.2993C17.3067 21.5023 18.1218 20.6842 18.1965 19.6795C18.2994 18.2939 18.4647 17.2103 18.3706 16.5183C18.3482 16.3539 18.3238 16.1891 18.3149 16.0234C18.1708 13.3544 15.7159 13.0378 14.5922 12.9778H10.631H8.84845C6.04251 13.2611 5.38946 10.2359 5.23206 9.06118L5.2791 2.94579C5.28224 2.53775 5.15749 2.12923 4.87042 1.83923Z",
    stroke: "#FB7C51",
    strokeWidth: 1.72092
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3891,
    cy: 6.82854,
    r: 3.64191,
    stroke: "#FB7C51",
    strokeWidth: 1.72092
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryIcon);
export default __webpack_public_path__ + "static/media/storyIcon.f41b1f4be0815e622f51376ca97725de.svg";
export { ForwardRef as ReactComponent };